"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var css = require("./index.scss");
//@ts-ignore
require("../theme.ts");
var Popover = /** @class */ (function (_super) {
    __extends(Popover, _super);
    function Popover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.close = function () {
            _this.fire('close');
        };
        _this.confirm = function () {
            _this.fire('confirm');
        };
        _this.left = 0;
        _this.top = 0;
        _this._docClickHandler = function () {
            //omi mode
            if (_this['__omiattr_']) {
                _this.props.show = false;
                _this['__omiattr_'].show = false;
            }
            //html element mode
            _this.removeAttribute('show');
            _this.fire('close');
        };
        _this.mouseDownHandler = function (evt) {
            evt.stopPropagation();
        };
        return _this;
    }
    Popover.prototype.uninstall = function () {
        document.removeEventListener('mousedown', this._docClickHandler);
    };
    Popover.prototype.updated = function () {
        this._setPosition();
    };
    Popover.prototype.installed = function () {
        document.addEventListener('mousedown', this._docClickHandler);
        this._setPosition();
    };
    Popover.prototype.getScopeRoot = function (current) {
        while (true) {
            var p = current.parentNode;
            if (p) {
                current = p;
            }
            else {
                return current;
            }
        }
    };
    Popover.prototype._setPosition = function () {
        if (this.props.show) {
            var rectA = this.shadowRoot.querySelector('.m-popover').getBoundingClientRect();
            var rectB = (typeof this.props.target === 'string' ? this.getScopeRoot(this).querySelector(this.props.target) : this.props.target).getBoundingClientRect();
            var tempLeft = void 0, tempTop = void 0;
            var st = document.documentElement.scrollTop || document.body.scrollTop;
            var sl = document.documentElement.scrollLeft || document.body.scrollLeft;
            switch (this.props.direction) {
                case 'top-left':
                    tempLeft = rectB.left;
                    tempTop = (rectB.top - rectA.height - 10);
                    break;
                case 'top':
                    tempLeft = rectB.left + (rectB.width / 2 - rectA.width / 2);
                    tempTop = (rectB.top - rectA.height - 10);
                    break;
                case 'top-right':
                    tempLeft = rectB.left + rectB.width - rectA.width;
                    tempTop = (rectB.top - rectA.height - 10);
                    break;
                case 'left':
                    tempLeft = rectB.left - rectA.width - 10;
                    tempTop = rectB.top + (rectB.height - rectA.height) / 2;
                    break;
                case 'left-top':
                    tempLeft = rectB.left - rectA.width - 10;
                    tempTop = rectB.top;
                    break;
                case 'left-bottom':
                    tempLeft = rectB.left - rectA.width - 10;
                    tempTop = rectB.top + (rectB.height - rectA.height);
                    break;
                case 'bottom-left':
                    tempLeft = rectB.left;
                    tempTop = (rectB.top + rectB.height + 10);
                    break;
                case 'bottom':
                    tempLeft = rectB.left + (rectB.width / 2 - rectA.width / 2);
                    tempTop = (rectB.top + rectB.height + 10);
                    break;
                case 'bottom-right':
                    tempLeft = rectB.left + rectB.width - rectA.width;
                    tempTop = (rectB.top + rectB.height + 10);
                    break;
                case 'right':
                    tempLeft = rectB.left + rectB.width + 10;
                    tempTop = rectB.top + (rectB.height - rectA.height) / 2;
                    break;
                case 'right-top':
                    tempLeft = rectB.left + rectB.width + 10;
                    tempTop = rectB.top;
                    break;
                case 'right-bottom':
                    tempLeft = rectB.left + rectB.width + 10;
                    tempTop = rectB.top + (rectB.height - rectA.height);
                    break;
            }
            tempLeft = tempLeft + this.props.x + sl + 'px';
            tempTop = tempTop + this.props.y + st + 'px';
            if (this.left !== tempLeft || this.top !== tempTop) {
                this.left = tempLeft;
                this.top = tempTop;
                this.update();
            }
        }
    };
    Popover.prototype.render = function (props) {
        if (!props.show)
            return;
        var cls = omi_1.classNames('_arrow', '_' + props.direction);
        var style = props.style, other = __rest(props, ["style"]);
        return (omi_1.h("div", __assign({ class: "m-popover", onMouseDown: this.mouseDownHandler, style: __assign({ left: this.left, top: this.top }, style) }, other),
            omi_1.h("div", { class: cls }),
            omi_1.h("div", { class: "m-inner" },
                omi_1.h("slot", null))));
    };
    Popover.css = css;
    Popover.defaultProps = {
        x: 0,
        y: 0
    };
    Popover.propTypes = {
        show: Boolean,
        x: Number,
        y: Number,
        direction: String,
        target: String
    };
    Popover = __decorate([
        omi_1.tag('m-popover')
    ], Popover);
    return Popover;
}(omi_1.WeElement));
exports.default = Popover;
